import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import {
  NodeColorSelector,
  NodeCurrentColor,
} from "@/components/doc/right-sidebar/node-viewer/NodeColorSelector";
import { setNodeColor } from "@/components/doc/right-sidebar/node-viewer/utils";
import { isNodeEditable } from "@/components/tiptap/lock/utils";

import { NodeProperty } from "../NodeProperty";

import type { ViewerNode } from "@/components/doc/right-sidebar/node-viewer/types";
import type { TailwindColor } from "@/utils/tailwindColors";

type Props = {
  node: ViewerNode;
  name?: string;
};

export const NodeColorProperty = observer(function NodeColorProperty({ node, name }: Props) {
  const t = useTranslations("sidebar");

  const handleColorChange = (color: TailwindColor) => {
    setNodeColor(node, color);
  };

  const editable = isNodeEditable(node);

  const property = (
    <NodeProperty
      name={name || t("nodeProps.color")}
      value={<NodeCurrentColor color={node.color} />}
      readOnly={!editable}
    />
  );

  if (!editable) {
    return property;
  }

  return (
    <NodeColorSelector
      color={node.color}
      triggerClassName="w-full"
      trigger={property}
      onSelect={handleColorChange}
    />
  );
});
